export const defaultWidth = 4056;
export const defaultHeight = 3040;
